"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacetItemsPopup = function (_React$Component) {
    (0, _inherits3.default)(FacetItemsPopup, _React$Component);

    function FacetItemsPopup() {
        (0, _classCallCheck3.default)(this, FacetItemsPopup);
        return (0, _possibleConstructorReturn3.default)(this, (FacetItemsPopup.__proto__ || (0, _getPrototypeOf2.default)(FacetItemsPopup)).apply(this, arguments));
    }

    (0, _createClass3.default)(FacetItemsPopup, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "dialog",
                { id: "facetFilteringDialog", className: "facet-filtering-dialog" },
                _react2.default.createElement(
                    "section",
                    { className: "filtering-header" },
                    _react2.default.createElement(
                        "div",
                        { className: "filtering-label" },
                        _react2.default.createElement(
                            "div",
                            null,
                            _react2.default.createElement(
                                "div",
                                { id: "filteringHeaderLabelIcon", className: "label-icon" },
                                "\xA0"
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "label-text" },
                                "User"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "filtering-header-main" },
                        _react2.default.createElement(
                            "div",
                            null,
                            _react2.default.createElement(
                                "div",
                                null,
                                _react2.default.createElement("input", { id: "filteringHeaderText", type: "text", placeholder: Resx.App.CartMartInput })
                            ),
                            _react2.default.createElement(
                                "div",
                                { className: "filtering-first-letters" },
                                "\xA0"
                            )
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "filtering-close-button" },
                        _react2.default.createElement(
                            "a",
                            null,
                            _react2.default.createElement("i", { className: "icon-delete" })
                        )
                    )
                ),
                _react2.default.createElement(
                    "section",
                    { id: "filteringBody", className: "filtering-body" },
                    "\xA0"
                ),
                _react2.default.createElement(
                    "section",
                    { className: "button-section" },
                    _react2.default.createElement(
                        "button",
                        { id: "popupFacetFilterButton", className: "btn btn-green green-big-button popup-facet-filter-button" },
                        Resx.Common.FilterAction
                    )
                )
            );
        }
    }]);
    return FacetItemsPopup;
}(_react2.default.Component);

exports.default = FacetItemsPopup;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/facets/components/facetItemsPopup.js
// module id = 401
// module chunks = 0 1